import type {
  ActivityToBook,
  BusinessCriteria,
  GraphQL,
} from '@libs/trip-planner-interfaces';

import { getApolloClient } from './infrastructure';
import { GET_TICKET_BOOKING_TOKENS_QUERY } from './queries';
import { getBookingTokenRequestQL } from './utils/requestMappers/bookingTokenRequestQL';
import { toBookingTokensResponse } from './utils/responseMappers/bookingTokensResponseQL';

export class ActivityBookingTokensService {
  public async getTokens(
    activitiesToBook: ActivityToBook[],
    businessCriteria: BusinessCriteria
  ): Promise<string[]> {
    const request = getBookingTokenRequestQL(
      activitiesToBook,
      businessCriteria
    );

    const response = await getApolloClient().query<
      GraphQL.getTicketBookingTokensQuery,
      GraphQL.getTicketBookingTokensQueryVariables
    >({
      query: GET_TICKET_BOOKING_TOKENS_QUERY,
      variables: {
        request,
      },
    });

    const tokens = response.data.bookingTokens;

    return toBookingTokensResponse(tokens);
  }
}
